import { render, staticRenderFns } from "./ReportCloseBoxes.vue?vue&type=template&id=0c0e02bc&"
import script from "./ReportCloseBoxes.vue?vue&type=script&lang=js&"
export * from "./ReportCloseBoxes.vue?vue&type=script&lang=js&"
import style0 from "./ReportCloseBoxes.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports